export interface AdminRoutePermission {
  route: string;
  permission: string;
  /** The route also needs an organization in the session (platform users such as SUPERADMIN have none). */
  requiresOrganization?: true;
}

/**
 * Top-level admin routes and the permission each one requires.
 * The order defines the landing priority for users that cannot open the dashboard.
 */
export const ADMIN_ROUTE_PERMISSIONS: readonly AdminRoutePermission[] = [
  { route: '/admin/dashboard', permission: 'dashboard:read' },
  { route: '/admin/management-qr', permission: 'qr:read' },
  { route: '/admin/lotes-qr', permission: 'qr-batch:read' },
  { route: '/admin/temas', permission: 'theme:read' },
  { route: '/admin/usuarios', permission: 'user:read' },
  { route: '/admin/organizaciones', permission: 'organization:manage' },
  { route: '/admin/mi-empresa', permission: 'organization:update', requiresOrganization: true },
];
